module.exports = __webpack_public_path__ + "images/ic-carat-down.svg";